'use strict';

var keyboardAccessibility = require('base/components/keyboardAccessibility');
var utils = require('org/util/utils');
var debounce = require('lodash/debounce');
var $siteNav = $('.site-header');
var openMenuDelay;
var isMobile = utils.isMobile();
var delayTime = isMobile ? 0 : 200;

var clearSelection = function (element) {
    var $element = $(element);
    var $menuContext = $element.closest('.dropdown, .dropdown-item');
    var $shownContext = $element.closest('.dropdown.show, .dropdown-item.show');

    $menuContext
        .children('.dropdown-menu, .menu-list')
        .children('.top-category, .nav-menu')
        .detach();

    $shownContext.children('.nav-link').attr('aria-expanded', 'false');
    $shownContext.removeClass('show');

    $element.closest('li.top-category, li.nav-menu').detach();
};

module.exports = function () {
    var isDesktopMenu = function (element) {
        return $(element).parents('.menu-toggleable-left').css('position') !== 'fixed';
    };

    // Handle Brands special first column
    if ($('.brands-first-column-item').length > 0 && !isMobile) {
        $('.brands-menu .menu-list .brands-first-column-item').clone().appendTo('.js-brands-first-col');
    } else {
        $('.js-brands-first-col').remove();
    }

    keyboardAccessibility('.main-menu .nav-link, .main-menu .dropdown-link',
        {
            40: function (menuItem) { // down
                if (menuItem.hasClass('nav-item')) { // top level
                    $('.navbar-nav .show').removeClass('show')
                        .children('.dropdown-menu')
                        .removeClass('show');
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    $(this).attr('aria-expanded', 'true');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                } else {
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.next().children().first().focus();
                }
            },
            39: function (menuItem) { // right
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.next().children().first().focus();
                } else if (menuItem.hasClass('dropdown')) {
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    $(this).attr('aria-expanded', 'true');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                }
            },
            38: function (menuItem) { // up
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                } else if (menuItem.prev().length === 0) {
                    menuItem.parent().parent().removeClass('show')
                        .children('.nav-link')
                        .attr('aria-expanded', 'false');
                    menuItem.parent().parent().children().first()
                        .focus();
                } else {
                    menuItem.prev().children().first().focus();
                }
            },
            37: function (menuItem) { // left
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.prev().children().first().focus();
                } else {
                    menuItem.closest('.show').removeClass('show')
                        .closest('li.show').removeClass('show')
                        .children()
                        .first()
                        .focus()
                        .attr('aria-expanded', 'false');
                }
            },
            27: function (menuItem) { // escape
                var parentMenu = menuItem.hasClass('show')
                    ? menuItem
                    : menuItem.closest('li.show');
                parentMenu.children('.show').removeClass('show');
                parentMenu.removeClass('show').children('.nav-link')
                    .attr('aria-expanded', 'false');
                parentMenu.children().first().focus();
            }
        },
            function () {
                return $(this).parent();
            }
        );

    $('.dropdown:not(.disabled) [data-toggle="sitenav"], a.has-sub-cat')
        .on('click', function (e) {
            if (!isDesktopMenu(this)) {
                e.preventDefault();
                // copy parent element into current UL
                var li = $('<li class="dropdown-item top-category" role="button"></li>');
                var link = $(this).clone().removeClass('dropdown-toggle')
                    .removeAttr('data-toggle')
                    .removeAttr('aria-expanded')
                    .attr('aria-haspopup', 'false');
                li.append(link);
                var closeMenu = $('<li class="nav-menu mb-0"></li>');
                closeMenu.append($('.close-menu').first().clone());
                if ($(this).hasClass('has-sub-cat')) {
                    $(this).closest('.dropdown-item').find('> .menu-list')
                    .prepend(li)
                    .prepend(closeMenu);
                    // copy navigation menu into view
                    $(this).closest('.dropdown-item').addClass('show');
                } else {
                    $(this).parent().children('.dropdown-menu')
                    .prepend(li)
                    .prepend(closeMenu);
                    // copy navigation menu into view
                    $(this).parent().addClass('show');
                }
                $(this).attr('aria-expanded', 'true');
                e.stopImmediatePropagation();
            }

            // Add support for expandable navigation to work on tablet landscape on click
            if (isMobile) {
                e.preventDefault();
            }
        })
        .on('mouseenter', function () {
            if (isDesktopMenu(this)) {
                var eventElement = this;
                $('.navbar-nav > li').each(function () {
                    if (!$.contains(this, eventElement)) {
                        $(this).find('.show').each(function () {
                            clearSelection(this);
                        });
                        // need to close all the dropdowns that are not direct parent of current dropdown
                        if ($(this).hasClass('show')) {
                            $(this).removeClass('show');
                            $(this).children('ul.dropdown-menu').removeClass('show');
                            $(this).children('.nav-link').attr('aria-expanded', 'false');
                        }
                    }
                });

                openMenuDelay = setTimeout(() => {
                    $(this).parent().addClass('show');
                    $(this).siblings('.dropdown-menu').addClass('show');
                    $(this).attr('aria-expanded', 'true');
                }, delayTime);
            }
        })
        .parent()
        .on('mouseleave', function () {
            if (isDesktopMenu(this)) {
                $(this).removeClass('show');
                $(this).children('.dropdown-menu').removeClass('show');
                $(this).children('.nav-link').attr('aria-expanded', 'false');
                clearTimeout(openMenuDelay);
            }
        });


    /**
     * Closes the side bar navigation menu
     * @param {Object} e - This passes in the event jQuery event
     */
    function menuClose(e) {
        e.preventDefault();
        $('.menu-toggleable-left').addClass('out');
        $('.menu-toggleable-left').removeClass('in');
        $('body').removeClass('overflow-hidden');
    }

    $('.navbar > .close-menu .close-button').on('click', function (e) {
        menuClose(e);
    });

    $('.navbar-nav').on('click', '.back', function (e) {
        e.preventDefault();
        clearSelection(this);
    });

    $('.navbar-nav').on('click', '.close-button', function (e) {
        e.preventDefault();
        $('.menu-row > .menu-list > .dropdown-item.show > .menu-list').addClass('slide-out'); // L3 menu
        setTimeout(function () {
            $('.navbar-nav').find('.top-category').detach();
            $('.navbar-nav').find('.nav-menu').detach();
            $('.menu-row > .menu-list > .dropdown-item.show > .menu-list').removeClass('slide-out'); // L3 menu
            $('.navbar-nav').find('.show').removeClass('show');
        }, 450);
        $('.navbar > .close-menu .close-button').trigger('click');
    });

    // hamburger menu
    $('.navbar-toggler').on('click', function (e) {
        e.preventDefault();
        $('.main-menu').removeClass('out');
        $('.main-menu').addClass('in');
        $('body').addClass('overflow-hidden');

        if ($siteNav.hasClass('is-stuck')) {
            $siteNav.removeClass('is-stuck');
        }
    });

    keyboardAccessibility('.navbar-header .user',
        {
            40: function ($popover) { // down
                if ($popover.children('a').first().is(':focus')) {
                    $popover.children('a').first().next().focus();
                } else {
                    $popover.children('a').first().focus();
                }
            },
            38: function ($popover) { // up
                if ($popover.children('a').first().is(':focus')) {
                    $(this).focus();
                    $popover.removeClass('show');
                } else {
                    $popover.children('a').first().focus();
                }
            },
            27: function ($popover) { // escape
                $(this).focus();
                $popover.removeClass('show');
            },
            9: function ($popover) { // tab
                $popover.removeClass('show');
            }
        },
        function () {
            var $popover = $('.user .popover');
            if (!($popover.hasClass('show'))) {
                $popover.addClass('show');
            }
            return $popover;
        }
    );

    $('.navbar-header .user').on('mouseenter focusin', function () {
        if ($('.navbar-header .user .popover').length > 0) {
            $('.navbar-header .user .popover').addClass('show');
        }
    });

    $('.navbar-header .user').on('mouseleave', function () {
        $('.navbar-header .user .popover').removeClass('show');
    });

    if (isMobile) {
        $(window).on('resize', debounce(function () {
            // If mobile menu is open and window resized beyon tablet portrait, close it.
            if ($('.main-menu').hasClass('in') && window.matchMedia('(min-width: 992px)').matches) {
                if ($('.main-menu').find('.show').last().length) {
                    $('.main-menu .close-button').last().trigger('click');
                } else {
                    $('.main-menu .close-button').first().trigger('click');
                }
            }

            // If Desktop nav is open and screen changed to tablet potrait, close it.
            if ($('.nav-item').hasClass('show') && (window.matchMedia('(min-width: 768px)').matches && window.matchMedia('(orientation: portrait)').matches)) {
                var $activeNav = $('.nav-item.show');
                $activeNav.removeClass('show').children('.dropdown-menu').removeClass('show');
                $activeNav.children('.nav-link').attr('aria-expanded', 'false');
            }
        }, 250));
    }

    if ($('.first-on-mobile')) {
        $('.first-on-mobile').parent().addClass('has-mobile-first');
    }
};
